import { useEffect, useState, useRef, useCallback } from "react";

function parseTarget(value) {
  const cleaned = String(value).replace(/[^0-9.]/g, "");
  return parseFloat(cleaned) || 0;
}

export function useCountUp(target, duration = 1800, startOnReveal = false) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(!startOnReveal);
  const rafRef = useRef(null);

  const start = useCallback(() => setStarted(true), [setStarted]);

  useEffect(() => {
    if (!started) return;

    const numericTarget = parseTarget(target);
    if (numericTarget === 0) {
      setCount(0);
      return;
    }

    const startTime = performance.now();

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(eased * numericTarget);

      if (progress < 1) {
        rafRef.current = requestAnimationFrame(tick);
      }
    }

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [target, duration, started, setCount]);

  const numericTarget = parseTarget(target);
  const targetStr = String(target);
  const prefix = targetStr.match(/^[^0-9]*/)?.[0] || "";
  const suffix = targetStr.match(/[^0-9.]*$/)?.[0] || "";

  let formatted;
  if (numericTarget % 1 !== 0) {
    formatted = count.toFixed(1);
  } else if (numericTarget >= 1000) {
    formatted = Math.round(count).toLocaleString();
  } else {
    formatted = Math.round(count).toString();
  }

  return { value: `${prefix}${formatted}${suffix}`, start, started };
}
